export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ExtraEscolarPage.vue?vue&type=template&id=44672304&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/ExtraEscolarPage.vue?vue&type=template&id=44672304&scoped=true&
// module id = 664
// module chunks = 7